/**
 * Bilingual copy for the VideoGallery component.
 * Video titles/descriptions come from the `videos` prop (its translations live in the
 * product data), so only the aria labels of this component's own controls live here.
 */
export const en = {
  playVideo: 'Play video',
  closeVideo: 'Close video',
};

export type Copy = typeof en;

export const km: Copy = {
  playVideo: 'ចាក់វីដេអូ',
  closeVideo: 'បិទវីដេអូ',
};
